import { createField, updateField } from '../../actions';
import { EVENT_STEP_VALIDATE } from '../../helpers/consts';


export class CheckboxField {
    constructor(options) {
        this.validateMessages = {
            isEmpty: __('Agree'),
        };
        this.store = options.store;
        this.state = this.store.getState();
        this.$context = options.$context;
        this.id = options.id;
        this.label = options.label;
        this.required = options.required !== undefined ? options.required : true;
        this.stepId = options.stepId
        const fieldState = this.state.formFields.find(field => field.id === this.id );
        this.checked = (fieldState && fieldState.value) ? fieldState.value : false;
        this.isValid = false;
        this.info = options.info;
        this.$el = this.createFieldElement();

        if (this.checked || !this.required) {
            this.validate();
        }
    }

    createFieldElement () { // eslint-disable-line class-methods-use-this
        let debounceTimeout;
        const $field = document.createElement('div');
        const $fieldLabel = document.createElement('label');
        this.$fieldInput = document.createElement('input');
        this.$fieldMessage = document.createElement('span');
        this.$fieldInfo = document.createElement('span');

        this.$fieldInput.type = 'checkbox';
        this.$fieldInput.id = this.id;
        this.$fieldInput.required = this.required;
        this.$fieldInput.checked = this.checked;
        $fieldLabel.setAttribute('for', this.id);
        $fieldLabel.innerHTML = this.label;

        $field.classList.add('form-check')
        $fieldLabel.classList.add('form-check-label');
        this.$fieldInput.classList.add('form-check-input');
        this.$fieldMessage.classList.add('invalid-feedback');
        this.$fieldMessage.setAttribute('role', 'alert');

        $fieldLabel.prepend(this.$fieldInput);

        if (this.info) {
            this.$fieldInfo.classList.add('label-info')
            this.$fieldInfo.dataset.toggle = 'tooltip';
            this.$fieldInfo.dataset.tooltip = this.info;
            this.$fieldInfo.dataset.placement = 'top';
            this.$fieldInfo.innerHTML = 'i';
            this.$fieldInfo.style.marginLeft = '5px';

            $fieldLabel.appendChild(this.$fieldInfo);
        }

        $field.appendChild($fieldLabel);
        $field.appendChild(this.$fieldMessage);

        this.store.dispatch(createField(this.id, this.label, this.stepId));
        this.$fieldInput.addEventListener('blur', this.validate.bind(this));
        this.$fieldInput.addEventListener('change', () => {
            clearTimeout(debounceTimeout);
            debounceTimeout = setTimeout(this.validate.bind(this), 100);
        });

        return $field;
    }

    validate() {
        this.$fieldInput.classList.remove('is-valid');
        this.isValid = false;

        if(this.$fieldInput.checked) {
            this.$fieldInput.classList.remove('is-invalid');
            this.$fieldInput.classList.add('is-valid');
            this.isValid = true;
        } else {
            this.$fieldInput.classList.add('is-invalid');
            this.$fieldInput.classList.remove('is-valid');
            this.isValid = false;
            this.$fieldMessage.innerHTML = this.validateMessages.isEmpty;
        }

        this.store.dispatch(updateField(this.id, this.$fieldInput.checked, this.isValid, this.label));
        this.$context.dispatchEvent(EVENT_STEP_VALIDATE);
    }

    valid() {
        return this.isValid;
    }

    render() {
        return this.$el;
    }
}

export default CheckboxField;
